import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSeason } from '../context/SeasonContext';
import api from '../api';
import './PlayoffNotificationModal.css';

const PlayoffNotificationModal = ({ isOpen, onClose, onDismiss }) => {
  const { effectiveSeason } = useSeason();
  const [playoff, setPlayoff] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      checkPlayoffStatus();
    }
  }, [isOpen, effectiveSeason]); // eslint-disable-line react-hooks/exhaustive-deps

  const checkPlayoffStatus = async () => {
    try {
      setLoading(true);
      const response = await api.getPlayoffStatus(effectiveSeason);
      if (response.data.exists && response.data.playoff.needs_prediction) {
        setPlayoff(response.data.playoff);
      } else {
        setPlayoff(null);
      }
    } catch (err) {
      console.error('Error checking playoff status:', err);
      setPlayoff(null);
    } finally {
      setLoading(false);
    }
  };

  const handleMakePrediction = () => {
    navigate('/playoff');
    if (onClose) {
      onClose();
    }
  };

  const handleDismiss = () => {
    if (onDismiss) {
      onDismiss();
    }
    if (onClose) {
      onClose();
    }
  };

  if (!isOpen || loading || !playoff) {
    return null;
  }

  return (
    <div className="playoff-modal-backdrop" onClick={handleDismiss}>
      <div className="playoff-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="playoff-modal-header">
          <h2>🏆 League Playoff Prediction Required</h2>
          <button className="close-button" onClick={handleDismiss}>×</button>
        </div>
        
        <div className="playoff-modal-body">
          <p className="modal-message">
            You are tied for first place and need to make a score prediction for the national championship game!
          </p>
          
          {playoff.game_id && (
            <div className="game-info">
              <p><strong>Game:</strong> {playoff.home_team_name} vs {playoff.away_team_name}</p>
            </div>
          )}
          
          {playoff.prediction_deadline && (
            <p className="deadline">
              <strong>Deadline:</strong> {new Date(playoff.prediction_deadline).toLocaleString()}
            </p>
          )}
          
          <div className="participants-info">
            <p><strong>Participants:</strong> {playoff.participants?.length || 0} users</p>
            <p className="submitted-count">
              {playoff.participants?.filter(p => p.has_prediction).length || 0} of {playoff.participants?.length || 0} predictions submitted
            </p>
          </div>
        </div>
        
        <div className="playoff-modal-actions">
          <button
            className="primary-button"
            onClick={handleMakePrediction}
          >
            Make Prediction
          </button>
          <button
            className="secondary-button"
            onClick={handleDismiss}
          >
            Remind Me Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlayoffNotificationModal;

